exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container.settings-options[data-v-5a0dc1ae] {\n  max-width: 600px;\n}\n.container.settings-options .form-item[data-v-5a0dc1ae] {\n    margin-bottom: 10px;\n}\n.image-container[data-v-5a0dc1ae] {\n  border-radius: 50%;\n  background-color: #d1f1ff;\n  width: 100px;\n  height: 100px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  font-size: 40px;\n  margin: auto;\n  margin-bottom: 15px;\n}\n", ""]);

// exports
